const NZ_TZ = 'Pacific/Auckland';

/**
 * Formats a timestamp as a short relative string ("5m ago", "3h ago", "2d ago"),
 * falling back to an absolute NZ date once it's more than a week old.
 */
export function formatTimeAgo(input: Date | string | null | undefined): string {
  if (!input) return '—';
  const date = typeof input === 'string' ? new Date(input) : input;
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days <= 7) return `${days}d ago`;
  return date.toLocaleDateString('en-NZ', { day: 'numeric', month: 'short', timeZone: NZ_TZ });
}
